import React from 'react';
import { BrowserRouter as Router, Switch, Redirect, Route } from 'react-router-dom';
import { Container } from 'reactstrap';

/* Context */
import UserContextProvider from '../context/User';

/* Components */
import AppNavigation from '../components/AppNavigation';
import Authenticated from '../components/Authenticated';

/* Pages */
import Login from '../pages/Login';
import Signup from '../pages/Signup';
import PrivacyPolicy from '../pages/PrivacyPolicy';
import RecoverPassword from '../pages/RecoverPassword';
import Orders from '../pages/Orders';
import Users from '../pages/Users';
import Order from '../pages/Order';
import '../modules/firebase';

const App = () => (
  <UserContextProvider>
    <Router>
      <AppNavigation />
      <Container>
        <Switch>
          <Redirect exact path="/" to="/login" />
          <Route name="Login" path="/login" component={Login} />
          <Route name="Signup" path="/signup" component={Signup} />
          <Route name="RecoverPassword" path="/recover-password" component={RecoverPassword} />
          <Route name="PrivacyPolicy" path="/privacy-policy" component={PrivacyPolicy} />
          <Authenticated name="Users" path="/users" component={Users} />
          <Authenticated name="Orders" path="/orders" component={Orders} />
          <Authenticated exact name="Order" path="/order/:userId/:orderId" component={Order} />
        </Switch>
      </Container>
    </Router>
  </UserContextProvider>
);

export default App;
